import { useMemo } from 'react';
import { DEFAULT_CHAIN, USDT_DATA } from '@package/smart-wallet/constants';
import { useSmartWallet } from '@package/smart-wallet/providers';
import { useAccount } from 'wagmi';

export const useGetDepositInfo = () => {
  const { chain } = useAccount();
  const { smartAccountAddress, isLoading } = useSmartWallet();

  /* Memo */
  const depositAddress = useMemo(() => {
    return smartAccountAddress;
  }, [smartAccountAddress]);

  const chainId = useMemo(() => {
    return chain?.id;
  }, [chain]);

  const {
    symbol: tokenSymbol,
    contractAddress: tokenAddress,
    name: tokenName,
    decimals: tokenDecimals,
  } = useMemo(() => {
    return (USDT_DATA as any)[chain?.id ?? DEFAULT_CHAIN.id];
  }, [chain]);

  /* Return */
  return {
    depositAddress,
    chainId,
    tokenSymbol,
    tokenAddress,
    tokenName,
    tokenDecimals,
    isLoading,
  };
};
